(() => {
  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) {
    const measure = () => document.documentElement.style.setProperty('--ex-menu-offset', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    else window.addEventListener('resize', measure, { passive: true });
  }
  async function loadRelated(root) {
    if (root.dataset.relatedReady || root.querySelector('[data-related-content]')) return;
    root.dataset.relatedReady = 'true';
    try {
      const url = new URL(root.dataset.recommendationsUrl, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.endsWith('/recommendations/products')) return;
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = [...html.querySelectorAll('[data-ex-related]')].find(node => node.dataset.sectionId === root.dataset.sectionId);
      const content = incoming?.querySelector('[data-related-content]');
      if (!content || !content.querySelector('.pulse-card')) return;
      root.replaceChildren(content);
      root.hidden = false;
      root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    } catch { /* No empty carousel or fabricated fallback when recommendations are unavailable. */ }
  }
  const initialize = scope => scope.querySelectorAll('[data-ex-related]').forEach(loadRelated);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
